<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kFA1DO/tc-custom/9781459291089.jpg?1726454432093" alt="This image is the cover for the book Return to Grace, The Home Valley Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Return to Grace, The Home Valley Series
      </h1>
      <p class="bookDescription body article font2">
        <b><i>Return to Home Valley with book two in Karen Harper’s fan-favorite romantic suspense series</i></b><br/><br/>Hannah Esh fled the Home Valley community with a broken heart, throwing herself into her dreams of a singing career, instead. Then, on a whim, she brings four new friends to the graveyard near her family's home for a midnight party on Halloween. But when shots are fired and one of her friends is killed, Hannah is pulled back into the world of her past. <br/><br/>The investigation into the shooting uncovers deeply buried secrets that shock the peaceful village to its core. Determined to prove her value to the community she left behind, Hannah attempts to bridge two cultures, working closely with handsome, arrogant FBI agent Linc Armstrong and her former betrothed, Seth Lantz, now widowed with a young daughter. <br/><br/>Caught between Seth and Linc, between old and new, Hannah must choose her future. Unless a killer, bent on secrecy, chooses it for her.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Karen Harper
      </h2>
      
      <p class="authorDescription body article">Karen Harper is the&#160;<I>New York Times</I>&#160;and<I> USA TODAY</I> bestselling author of romantic suspense. A former Ohio State University English instructor,&#160;she now writes full time. Harper is the winner of The Mary Higgins Clark Award for her novel, DARK ANGEL. She also writes historical novels set in Tudor England.&#160; Please visit or write her at her website at &#160;<a href="http://www.KarenHarperAuthor.com">www.KarenHarperAuthor.com</a></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1dedf08e